import React from 'react';
import {Result} from 'antd';
import { ApolloError } from '@apollo/client';
import {t} from "../i18n";
import {ResultStatusType} from "antd/es/result";


export interface ErrorInfoProps {
    error: ApolloError;
}

// TODO: 需要优化,根据错误类型显示不同的错误信息
export const ErrorInfo: React.FC<ErrorInfoProps> = ({ error }) => {
    let status: ResultStatusType = '500';
    let messageKey = 'errors.system.unknownError';

    if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
        const graphQLError = error.graphQLErrors[0];
        const code = graphQLError.extensions?.code;
        if (graphQLError.extensions?.messageKey) {
            messageKey = graphQLError.extensions.messageKey as string;
        }
        // 默认使用错误消息
        switch(code) {
            case 'UNAUTHORIZED':
                status = '403'
                break;
            case 'PERMISSION':
                status = '403'
                break;
            default:
                break;
        }
    } 

    const details = JSON.stringify(error);

    return (
        <div className="flex flex-col items-center">
            <Result
                status={status}
                title={'Error'}
                subTitle={t(messageKey)}
            />
            <details className="bg-gray-50 px-4">
                <summary className="cursor-pointer">Details</summary>
                <div className="p-2 rounded">
                    {details}
                </div>
            </details>
        </div>
    );
};
